// Keep these in selectability order: https://www.mariowiki.com/Mario_Kart_8_Deluxe#Available_parts
export const GLIDERS = [
  //                                                               Speed x4,      Acc, Wt,    Handling x4,    Trac, Mini-Turbo, Invincibility
  [['Cloud Glider', 'Parachute', 'Flower Glider', 'Paper Glider'], 0, 1, 1, 1,    2,   0,     1, 0, 2, 1,     1,    2,          0],
  [['Peach Parasol', 'Parafoil', 'Bowser Kite', 'MKTV Parafoil'],  0, 0, 1, 1,    2,   1,     1, 1, 2, 0,     0,    2,          0],
  [['Wario Wing', 'Plane Glider', 'Gold Glider', 'Paraglider'],    1, 0, 2, 1,    1,   2,     1, 1, 1, 0,     0,    1,          1],
  [['Super Glider', 'Waddle Wing', 'Hylian Kite'],                 1, 1, 2, 0,    1,   1,     1, 0, 1, 1,     1,    1,          1]
];
